import React from 'react';
import { MobXProviderContext } from 'mobx-react';

import type {
  AdmissionStoreType,
  ApplicationStoreType,
  AppStoreType,
} from '@/stores';
import type { MentorCalendarStoreType } from '@/stores/MentorCalendarStore';
import type { StudentCalendarStoreType } from '@/stores/StudentCalendarStore';
import type { UserStoreType } from '@/stores/UserStore';

type Stores = {
  appStore: AppStoreType;
  applicationStore: ApplicationStoreType;
  admissionStore: AdmissionStoreType;
  userStore: UserStoreType;
  mentorCalendarStore: MentorCalendarStoreType;
  studentCalendarStore: StudentCalendarStoreType;
};

export const useStores = (): Stores => {
  return React.useContext(MobXProviderContext) as Stores;
};
